

import { PAYMENTS_URL } from '../constants'

const headers = () => {
	const accessToken = localStorage.getItem('accessToken')
	const headers = {
		'Content-Type': 'application/json',
		'x-analytics-source': 'web'
	}
	if (accessToken) headers['Authorization'] = `Bearer ${accessToken}`

	return headers
}

export const validateCouponCode = (coupon, signal) => {
  if (!coupon) return { valid: false }
  const opts = {
    method: 'GET',
    headers: headers(),
    signal: signal,
  }

  try {
    const result = fetch(`${PAYMENTS_URL}/payments/coupons/validate/${coupon}`, opts).then((data) => data.json())

    return result
  } catch (err) {
    console.error('[Payments Api]: ', err)
    return { valid: false }
  }
}

export const checkCouponCode = (coupon, signal) => {
  if (!coupon) return { valid: false }
  const opts = {
    method: 'GET',
    headers: headers(),
    signal: signal,
  }

  try {
    const result = fetch(`${PAYMENTS_URL}/payments/coupons/code/${coupon}`, opts).then((data) => data.json())

    return result
  } catch (err) {
    console.error('[Payments Api]: ', err)
    return { valid: false }
  }
}

// *********** FETCH ALL COUPON CODES - this should only be used for the admin dashboard *********** //
export const fetchCouponCodes = async () => {
  const opts = {
    method: 'GET',
    headers: headers(),
  }
  const stripe_coupons = await fetch(`${PAYMENTS_URL}/payments/coupons/list`, opts).then((data) => data.json())

  return stripe_coupons
}

export const deleteCoupon = async (id) => {
  const opts = {
    method: 'DELETE',
    headers: headers(),
  }
  const result = await (await fetch(`${PAYMENTS_URL}/payments/coupons/${id}`, opts)).json()

  return result
}

export const createCoupon = async (coupon) => {
  const opts = {
    method: 'POST',
    headers: headers(),
    body: JSON.stringify(coupon),
  }
  const result = await (await fetch(`${PAYMENTS_URL}/payments/coupons/create`, opts)).json()

  return result
}
